import { VEHICLE_SCHEMA_ID_FRAGMENT } from '@/modern/components/Seo/schemas/constants'

export function getItemCondition(spec) {
  const mileageValue = Number.parseFloat(spec.Odometer)
  if (!Number.isFinite(mileageValue)) return undefined
  return mileageValue === 0 ? 'NewCondition' : 'UsedCondition'
}

export function buildSchemaId(canonical) {
  return canonical ? `${canonical}${VEHICLE_SCHEMA_ID_FRAGMENT}` : undefined
}
